import React from 'react';
import AsyncContainer from '../containers/AsyncContainer';
import ContinueContainer from '../containers/ContinueContainer';
import LogoutContainer from '../containers/LogoutContainer';
import UnlinkEmailAccountContainer from '../containers/UnlinkEmailAccountContainer';
import UnsubscribeContainer from '../containers/UnsubscribeContainer';
import RestoreContainer from '../containers/RestoreContainer';
import AutoSignupContainer from '../containers/AutoSignupContainer';

const AsyncRestoringContainer = AsyncContainer(() => import('../containers/RestoringContainer'));

export default [
  {
    path: '/logout',
    component: <LogoutContainer />,
  },
  {
    path: '/continue',
    component: <ContinueContainer />,
  },
  {
    path: '/restoring',
    component: <AsyncRestoringContainer />,
  },
  {
    path: '/unlink',
    component: <UnlinkEmailAccountContainer />,
  },
  {
    path: '/unsubscribe',
    component: <UnsubscribeContainer />,
  },
  {
    path: '/restore',
    component: <RestoreContainer />,
  },
  {
    path: '/account-migration',
    component: <AutoSignupContainer />,
  },
];
